class ClientSSOMetadata {
    constructor(
      public client_name: string,
      public client_uri: string,
      public grant_types: string,
      public redirect_uris: string,
      public response_types: string,
      public scope: string,
      public token_endpoint_auth_method: string
    ) {}
  }
  
  export default ClientSSOMetadata;
  